export enum ContextualHelpCode {
  QUERY_BUILDER = 'queryBuilder',
  REQUEST = 'request'
}
